import map from 'lodash/map';
import merge from 'lodash/merge';

export interface IState {
  name: string;
  value: string;
}

export const STATES = {
  'United States': {
    AL: $localize`Alabama`,
    AK: $localize`Alaska`,
    AS: $localize`American Samoa`,
    AZ: $localize`Arizona`,
    AR: $localize`Arkansas`,
    CA: $localize`California`,
    CO: $localize`Colorado`,
    CT: $localize`Connecticut`,
    DE: $localize`Delaware`,
    DC: $localize`District of Columbia`,
    FL: $localize`Florida`,
    GA: $localize`Georgia`,
    GU: $localize`Guam`,
    HI: $localize`Hawaii`,
    ID: $localize`Idaho`,
    IL: $localize`Illinois`,
    IN: $localize`Indiana`,
    IA: $localize`Iowa`,
    KS: $localize`Kansas`,
    KY: $localize`Kentucky`,
    LA: $localize`Louisiana`,
    ME: $localize`Maine`,
    MD: $localize`Maryland`,
    MA: $localize`Massachusetts`,
    MI: $localize`Michigan`,
    MN: $localize`Minnesota`,
    MS: $localize`Mississippi`,
    MO: $localize`Missouri`,
    MT: $localize`Montana`,
    NE: $localize`Nebraska`,
    NV: $localize`Nevada`,
    NH: $localize`New Hampshire`,
    NJ: $localize`New Jersey`,
    NM: $localize`New Mexico`,
    NY: $localize`New York`,
    NC: $localize`North Carolina`,
    ND: $localize`North Dakota`,
    OH: $localize`Ohio`,
    OK: $localize`Oklahoma`,
    OR: $localize`Oregon`,
    PA: $localize`Pennsylvania`,
    PR: $localize`Puerto Rico`,
    RI: $localize`Rhode Island`,
    SC: $localize`South Carolina`,
    SD: $localize`South Dakota`,
    TN: $localize`Tennessee`,
    TX: $localize`Texas`,
    UT: $localize`Utah`,
    VT: $localize`Vermont`,
    VA: $localize`Virginia`,
    VI: $localize`Virgin Islands`,
    WA: $localize`Washington`,
    WV: $localize`West Virginia`,
    WI: $localize`Wisconsin`,
    WY: $localize`Wyoming`,
  },
  'Canada': {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NT: 'Northwest Territory',
    NS: 'Nova Scotia',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon Territory',
  },
  'Mexico': {
    AG: 'Aguascalientes',
    BN: 'Baja California Norte',
    BS: 'Baja California Sur',
    CS: 'Chiapas',
    CP: 'Campeche',
    CH: 'Coahuila',
    CI: 'Chihuahua',
    CL: 'Colima',
    DF: 'Ciudad de México',
    DG: 'Durango',
    GE: 'Guerrero',
    GJ: 'Guanajuato',
    HD: 'Hidalgo',
    JA: 'Jalisco',
    MX: 'Estado de México',
    MC: 'Michoacan',
    MR: 'Morelos',
    NA: 'Nayarit',
    OA: 'Oaxaca',
    PU: 'Puebla',
    QI: 'Quintana Roo',
    QE: 'Queretaro',
    SL: 'San Luis Potosi',
    SI: 'Sinaloa',
    SO: 'Sonora',
    TB: 'Tabasco',
    TA: 'Tamaulipas',
    TL: 'Tlaxcala',
    VC: 'Veracruz',
    YU: 'Yucatan',
    ZA: 'Zacatecas',
  },
};

export function getStates(country: 'us' | 'canada' | 'mexico' | 'all'): IState[] {
  if (country === 'us') return transform(STATES['United States']);
  if (country === 'canada') return transform(STATES['Canada']);
  if (country === 'mexico') return transform(STATES['Mexico']);
  if (country === 'all') return transform(merge({}, STATES['United States'], STATES['Canada']));
}

export function getState(country: string, state: string): string {
  return STATES[country][state];
}

export function getCountryFromState(state: string): string {
  for (const country in STATES) {
    if (STATES[country].hasOwnProperty(state)) {
      return country;
    }
  }
  return null; // Return null if stateKey is not found
}

function transform(items): IState[] {
  return map(items, (name, value) => {
    return { name, value };
  });
}
